import Nav from "../Nav";

function Footer() {
  return (
    <footer>
      <Nav />
    </footer>
  );
}

export default Footer;
